import React from "react";
import styles from "./HorizonScene.module.scss";
import BannerMain from "./BannerMain/BannerMain";

const HorizonScene = () => {
  return (
    <div className={styles.scene}>
      <BannerMain />
      <div id={styles.earth}></div>
    </div>
  );
};

export default HorizonScene;
